import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrl: './error.component.css'
})
export class ErrorComponent {
  constructor(private location: Location, private router: Router) { }
  goBack() {
    this.location.back();
  }
  goBackHome() {
    this.router.navigate(['/log-in']);
  }
}
